exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link{cursor:pointer}.anim-wrapper{background-color:#000;position:relative}.anim-wrapper .hero{position:absolute;top:50%;margin-top:-40px;left:0;right:0}#home h4{font-size:2.5rem}#home h5{font-size:1.5rem;font-weight:700}.title-overlay .card-body{position:absolute;bottom:0;left:0;right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14596135","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/Main.vue
// module id = 273
// module chunks = 0